import { Payment } from '../../payment/Payment';
import { OnboardingShell } from '../OnboardingShell';

export const PricingStep = (props) => {
	const { stepIndex, totalSteps, onBack, onNext } = props;

	const handlePlanSelected = (link) => {
		if (link) {
			window.location.href = link;
			return;
		}
		if (onNext) onNext();
	};

	return (
		<OnboardingShell
			stepIndex={stepIndex}
			totalSteps={totalSteps}
			onBack={onBack}
			showBack={!!onBack}
			hideFooter={true}
			fullBleed={true}>
			<Payment onboarding={true} onPlanSelected={handlePlanSelected} />
		</OnboardingShell>
	);
};
